import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";
import { SecondaryText } from "@/components/Typography/Styled";

export const StyledSBSKUSum = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.itemBorder} !important;
`;

export const StyledSBSKURaw = styled(FlexContainer)`
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 16px 12px 0;
    border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }
`;

export const StyledSBSKUInfoIcon = styled(InfoCircleOutlined)`
    font-size: 14px;
    color: ${({ theme }) => theme.primaryTypographyColor};
`;

export const StyledSBSKSum = styled(SecondaryText)`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.itemBorder} !important;
    text-wrap: nowrap;
`;
